import { render } from "./LModal.vue?vue&type=template&id=56258d86"
import script from "./LModal.vue?vue&type=script&lang=js"
export * from "./LModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__